<template>
  <div class="mcontents">
    <div class="mix-tree-list" v-for="(zz,xx) in arr" :key="xx">
      <div
        v-for="(item, index) in zz"
        :key="index"
        class="mix-tree-item parent underborder"
        :style="[{
							paddingLeft:(item.rank *16 ) + 16 +'px',
							zIndex: item.rank*-1 +50
						}]"
        v-bind:class="{
							border: treeParams.border === true,
							unshow: !item.show,
							last: item.lastRank,
							back: item.rank > 0 && !item.lastRank,
              toback:item.rank > 0 && item.lastRank,
							showchild: item.showChild,
						}"
            @click.stop="treeItemTap(item, index)"
      >
        <img
          class="mix-tree-icon lefticon"
          :src="item.lastRank ? treeParams.lastIcon :treeParams. parentIcon"
        />
        <div class="contents">
          <div class="name" >{{item.name}}</div>
          <div class="rate" v-if="item.star > 0">
            <div>常考度</div>
            <img
              v-for="n in item.star"
              :key="n"
              src="@img/Collection_default@2x.png"
              mode
              style="width: 12px;height: 12px;"
            />
          </div>
          <div class="plan" v-if="!item.is_err && signs != 2  && signs != 3 && item.name != '默认课程'">
            <div class="total">{{item.all_num + '/'+(item.question_num == null || item.question_num == '' ? 0 :item.question_num)}}</div>
            <div>{{'正确率：'+ item.accuracy}}</div>
          </div>
          <div
            class="hisText"
            v-if="item.is_his && item.is_finished == 0"
          >{{formatDate(new Date(item.create_time)) +'，共'+item.question_num+'道题，未做完'}}</div>
          <div
            class="hisText"
            v-if="item.is_his && item.is_finished == 1"
          >{{formatDate(new Date(item.create_time)) +'，共'+item.question_num+'道题，已做完' }}</div>
          <div class="hisText" v-if="item.is_err">{{'错误'+item.error_num+'题' }}</div>
          <div class="hisText" v-if="item.is_cet">{{'收藏'+item.question_num+'题' }}</div>
          <div class="hisText" v-if="item.is_exam">
            <div class="first">{{'共'+item.question_num+'题'}}</div>
            <div>{{ '正确率'+item.accuracy }}</div>
          </div>
        </div>
        <img
          class="mix-tree-icon"
          v-if="!item.lastRank"
          :src="item.showChild? treeParams.currentIcon : treeParams.defaultIcon"
        />
        <div class="totest" v-if="item.lastRank">开始练习</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    sign: {
      type: Number,
      default(){}
    }
  },
  data() {
    return {
      treeList: [],
      arr: [],
      treeParams: {
        defaultIcon: require("@img/fold@2x.png"),
        currentIcon: require("@img/unfold@2x.png"),
        lastIcon: require("@img/part@2x.png"),
        parentIcon: require("@img/chapters.png"),
        border: false
      },
      signs: ''
    };
  },
  watch: {
    sign(sign) {
      this.signs = sign
    },
    list(list) {
      // console.log('xxxx', list)
      this.treeList = [];
      this.treeParams = Object.assign(this.treeParams, this.params);
      // console.log(this.treeParams, this.params);
      this.renderTreeList(list);
      this.sliceTreeList();
    }
  },
  created(){
    
  },
  methods: {
    formatDate(date) {
      let formatDate =
        date.getFullYear() +
        "." +
        (date.getMonth() + 1) +
        "." +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        (date.getMinutes() < 10 ? "0" : "") +
        date.getMinutes() +
        ":" +
        (date.getSeconds() < 10 ? "0" : "") +
        date.getSeconds();
      return formatDate;
    },
    //扁平化树结构
    renderTreeList(list = [], rank = 0, parentId = []) {
      this.arr = [];
      // console.log('22222',list)
      list.forEach(item => {
        this.treeList.push({
          id: item.id || item.paper_id || item.course_id,
          name: item.title,
          parentId, // 父级id数组
          rank, // 层级
          showChild: false, //子级是否显示
          show: this.sign != 1 ? rank === 0: rank === 1, // 自身是否显示
          is_who: item.id || item.paper_id ? "papers" : "children",
          menu: item.menu ? "yes" : "not",
          is_menu: item.is_menu ? true : false,
          is_err:  item.error_num > 0 ? true : false,
          is_his: item.is_his ? true : false,
          is_cet: item.is_cet ? true : false,
          is_exam: item.is_exam ? true : false,
          star: item.star ? parseInt(item.star) : "",
          do_num: item.do_num,
          all_num: item.all_num?item.all_num:0,
          total_question_num: item.total_question_num,
          total_right_num: item.right_num,
          create_time: item.create_time ? item.create_time : "",
          is_finished: item.is_finished ? item.is_finished : 0,
          question_num: item.question_num ? item.question_num : 0,
          error_num: item.error_num,
          // accuracy: Math.round(item.all_num/item.question_num)/100.00,
          accuracy: this.GetPercent(item.right_num,item.question_num),
          category: item.category,
          course_id:item.course_id
        });
        // if (this.signs == 2) {
        //   console.log(this.treeList)
        // }
        if (
          (Array.isArray(item.children) && item.children.length > 0) ||
          (Array.isArray(item.papers) && item.papers.length > 0)
        ) {
          if (Array.isArray(item.children) && item.children.length > 0) {
            let parents = [...parentId];
            parents.push(item.course_id || item.id);
            this.renderTreeList(item.children, rank + 1, parents);
          }
          if (Array.isArray(item.papers) && item.papers.length > 0) {
            let parents = [...parentId];
            parents.push(item.course_id || item.id);
            this.renderTreeList(item.papers, rank + 1, parents);
          }
        } else {
          this.treeList[this.treeList.length - 1].lastRank = true;
        }
        if (item.children == '' && item.papers == '') {
          this.treeList[this.treeList.length - 1].lastRank = false;
        }
      });
      
    },
    GetPercent(num, total) {
      /// <summary>
      /// 求百分比
      /// </summary>
      /// <param name="num">当前数</param>
      /// <param name="total">总数</param>
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
          return "-";
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00)+"%";
    },
    //分割树结构
    sliceTreeList() {
      //记录每个最上级父节点的位置
      let num = [];
      this.treeList.forEach((item, index) => {
        if (item.rank == 0) {
          num.push(index);
        }
      });
      //分割树结构
      if (num.length == 1) {
        this.arr.push(this.treeList);
      } else if (num.length > 1) {
        for (let index = 0; index < num.length; index++) {
          if (index < num.length - 1) {
            this.arr.push(this.treeList.slice(num[index], num[index + 1]));
          } else if (index == num.length - 1) {
            this.arr.push(this.treeList.slice(num[index]));
          }
        }
      }
      console.log(this.arr)
    },
    // 点击
    treeItemTap(item) {
      let list = this.treeList;
      // console.log('xxxx',item)
      let id = item.id;
      if (item.lastRank === true && item.is_who == "papers") {
        //点击最后一级时触发事件
        this.$emit("treeItemClick", item);
        return;
      }
      if (item.lastRank === true && item.is_who == "papers") {
        //点击最后一级时触发事件
        this.$emit("treeItemClick", item);
        return;
      }
      item.showChild = !item.showChild;
      list.forEach(childItem => {
        if (item.showChild === false) {
          //隐藏所有子级
          if (!childItem.parentId.includes(id)) {
            return;
          }
          if (childItem.lastRank !== true) {
            childItem.showChild = false;
          }
          childItem.show = false;
        } else {
          if (childItem.parentId[childItem.parentId.length - 1] === id) {
            childItem.show = true;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.mcontents {
  width: 100%;
  /* padding-bottom: 40px; */
}
.mix-tree-list {
  display: flex;
  flex-direction: column;
  border: 1px solid #ebebeb;
  border-bottom: none;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 25px;
}

.mix-tree-list .parent {
  height: 64px;
}

.mix-tree-list .back {
  background: #f8f9fa;
}
.mix-tree-list .toback {
  background: #f0f2f5;
}
.mix-tree-list .underborder {
  border-bottom: 1px solid #ebebeb;
}
.mix-tree-item {
  display: flex;
  font-size: 30px;
  color: #333;
  opacity: 1;
  padding-right: 16px;
  transition: 0.2s;
  position: relative;
  align-items: center;
}
.mix-tree-item .totest {
  width: 74px;
  height: 25px;
  background: #3b9dff;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.mix-tree-item .contents {
  display: flex;
  flex: 1;
  align-items: flex-start;
  align-items: center;
}
.mix-tree-item .lefticon {
  margin-right: 16px;
}
.contents .hisText {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.contents .hisText .first {
  margin-right: 16px;
}
.mix-tree-item .box {
  display: flex;
  align-items: center;
}

.contents .underbank {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.contents .rate {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.contents .plan {
  display: flex;
  align-items: center;
  flex-direction: row;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
}
.contents .rate div {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  margin-right: 7px;
}
.mix-tree-item.border {
  border-bottom: 1px solid #eee;
}
.contents .name {
  margin-right: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
}
.contents .plan .total {
  margin-right: 32px;
  margin-left: 32px;
}
.mix-tree-item.unshow {
  display: none;
}

.mix-tree-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.mix-tree-item.showchild:before {
  transform: rotate(90deg);
}

.mix-tree-item.last {
  justify-content: space-between;
}
</style>
